import {
  GetPaymentPlanNextRunQuery,
  GetPaymentPlanNextRunQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { useWrappedQuery } from './use-wrapped-query';

export const GET_PAYMENT_PLAN_NEXT_RUN_QUERY = gql`
  query GetPaymentPlanNextRun($restaurantUUID: uuid!, $supplierUUID: uuid!) {
    getPaymentPlanNextRunDate(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      estimated_end_date
      next_run_date
      payment_plan {
        installment_amount_in_micros
        start_date
        total_amount_in_micros
        task_frequency_settings {
          frequency
        }
        supplier {
          name
          uuid
        }
        uuid
      }
    }
  }
`;

export const useGetPaymentPlanNextRun = (
  restaurantUUID: string,
  supplierUUID: string,
) => {
  return useWrappedQuery<
    GetPaymentPlanNextRunQuery,
    GetPaymentPlanNextRunQueryVariables
  >(GET_PAYMENT_PLAN_NEXT_RUN_QUERY, {
    variables: { restaurantUUID, supplierUUID },
  });
};
